const SCENARIOS = [
  {
    id: 'SSP2-4.5',
    label: 'Medium emissions',
  },
  {
    id: 'SSP5-8.5',
    label: 'High emissions',
  },
];

const HORIZONS = [
  {
    id: '2000-2024',
    label: 'Baseline',
  },
  {
    id: '2025-2054',
    label: '2025-2054',
  },
  {
    id: '2055-2084',
    label: '2055-2084',
  },
];

const REGIONS = [{ district: 'Chitipa', lat: -9.7038, lng: 33.27 }, { district: 'Karonga', lat: -9.9036, lng: 33.975 }, { district: 'Mzimba', lat: -11.8543, lng: 33.6078 }, { district: 'Nkhata Bay', lat: -11.653, lng: 34.0532 }, { district: 'Rumphi', lat: -10.8029, lng: 33.8052 }, { district: 'Dedza', lat: -14.2627, lng: 34.1856 }, { district: 'Dowa', lat: -13.6009, lng: 33.8238 }, { district: 'Kasungu', lat: -13, lng: 33.4167 }, { district: 'Lilongwe', lat: -14.0196, lng: 33.6841 }, { district: 'Mchinji', lat: -13.7623, lng: 33.0799 }, { district: 'Nkhotakota', lat: -12.8042, lng: 34.083 }, { district: 'Ntcheu', lat: -14.75, lng: 34.75 }, { district: 'Ntchisi', lat: -13.2957, lng: 33.908 }, { district: 'Salima', lat: -13.75, lng: 34.5 }, { district: 'Balaka', lat: -15.0507, lng: 35.0829 }, { district: 'Blantyre', lat: -15.7861, lng: 35.0058 }, { district: 'Chikwawa', lat: -16.0335, lng: 34.8009 }, { district: 'Chiradzulu', lat: -15.7423, lng: 35.2588 }, { district: 'Machinga', lat: -14.9407, lng: 35.4782 }, { district: 'Mangochi', lat: -14.1388, lng: 35.0388 }, { district: 'Mulanje', lat: -16.0258, lng: 35.5081 }, { district: 'Mwanza', lat: -15.6334, lng: 34.5168 }, { district: 'Neno', lat: -15.4505, lng: 34.7003 }, { district: 'Nsanje', lat: -16.75, lng: 35.1667 }, { district: 'Thyolo', lat: -16.0693, lng: 35.1406 }, { district: 'Phalombe', lat: -15.7633, lng: 35.6588 }, { district: 'Zomba', lat: -15.3766, lng: 35.3357 }]
  .sort((a, b) => a.district.localeCompare(b.district));

const RISK_COLORS = {
  'Very High': '#FE375B',
  High: '#FE8737',
  Medium: '#FECC37',
  Low: '#72A276',
};

const VIRIDIS_COLORS = [
  '#440154', // Dark purple (bottom - value 15)
  '#482777',
  '#3f4a8a',
  '#31678e',
  '#26838f',
  '#1f9d8a',
  '#6cce5a',
  '#b6de2b',
  '#fee825', // Bright yellow (top - value 50)
];

const VIRIDIS_GRADIENT_STOPS = VIRIDIS_COLORS.map((color, index) => `${color} ${(index / (VIRIDIS_COLORS.length - 1)) * 100}%`).join(', ');

const MIN_VALUE = 18;
const MAX_VALUE = 50;
const DIVISIBLE_BY = 10;

function computeLabels(min, max, divisor) {
  const labels = new Set();

  labels.add(min);
  labels.add(max);

  for (let i = Math.ceil(min / divisor) * divisor; i <= max; i += divisor) {
    if (i >= min && i <= max) {
      labels.add(i);
    }
  }

  return Array.from(labels)
    .sort((a, b) => b - a)
    .map(value => ({
      value,
      position: ((max - value) / (max - min)) * 100,
    }));
}

const VIRIDIS_LABELS = computeLabels(MIN_VALUE, MAX_VALUE, DIVISIBLE_BY);
const VIRIDIS_MIN_MAX_LABELS = computeLabels(MIN_VALUE, MAX_VALUE, MAX_VALUE - MIN_VALUE);

export {
  HORIZONS,
  REGIONS,
  RISK_COLORS,
  SCENARIOS,
  VIRIDIS_GRADIENT_STOPS,
  VIRIDIS_LABELS,
  VIRIDIS_MIN_MAX_LABELS,
};
